<!--
 * @Description: 商机页面
 * @Author: mdb
 * @Date: 2022-06-23 20:31:59
 * @LastEditTime: 2023-06-29 16:26:14
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <a-tabs v-model:activeKey="queryForm.dataType" @change="handleTabsChange">
        <a-tab-pane key="all" tab="全部" />
        <a-tab-pane key="me" tab="我的商机" />
        <a-tab-pane key="subUser" tab="下属商机" />
      </a-tabs>
      <cos-table
        serial
        :columns="columns"
        v-model:search="queryForm"
        :row-selection="{ onChange: onSelectRowsChange }"
        @fetch="getList"
        @mask="showMask"
        ref="tableRef"
        rowKey="id"
        tableId="business_table"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item name="customerName" label="客户名称" :span="12">
              <a-textarea
                v-model:value="queryForm.customerName"
                :autoSize="{ minRows: 1, maxRows: 4 }"
                placeholder="请输入客户名称"
              />
            </dc-form-item>
            <dc-form-item name="tmsCode" label="客户代码" :span="12">
              <a-textarea
                v-model:value="queryForm.tmsCode"
                :autoSize="{ minRows: 1, maxRows: 4 }"
                placeholder="请输入客户代码"
              />
            </dc-form-item>
            <dc-form-item name="customerNumber" label="主账号代码">
              <a-input
                v-model:value="queryForm.customerNumber"
                :maxlength="200"
                allowClear
                placeholder="请输入主账号代码"
              />
            </dc-form-item>
            <dc-form-item name="status" label="商机状态">
              <a-select
                v-model:value="queryForm.statusList"
                :options="businessStatusEnum"
                placeholder="请选择商机状态"
                allowClear
                mode="multiple"
              />
            </dc-form-item>
            <dc-form-item name="dutyBy" label="客户负责人" v-if="queryForm.dataType !== 'me'">
              <UserSelect permission v-model:value="queryForm.dutyByList" placeholder="请选择客户负责人" mode="multiple" allowClear />
            </dc-form-item>
            <dc-form-item name="contactMobile" label="手机号">
              <a-input
                v-model:value.trim="queryForm.contactMobile"
                :maxlength="100"
                allowClear
                placeholder="请输入手机号"
              />
            </dc-form-item>
            <dc-form-item name="customerAreaIdList" label="客户区域" v-if="queryForm.dataType !== 'me'">
              <CustomerAreaCascader
                type="search"
                appId="cos_lbu"
                v-model:ids="queryForm.customerAreaIdList"
                placeholder="请选择客户区域"
              />
            </dc-form-item>
            <dc-form-item label="员工区域">
              <CustomerAreaCascader type="search" appId="cos_lbu" v-model:ids="queryForm.employeeRegionList" />
            </dc-form-item>
            <dc-form-item name="requiredCountry" label="目的地国家">
              <ParamCodesSelect
                v-model:value="queryForm.requiredCountryList"
                :options="paramCodeData.lbu_demand_country"
                placeholder="请选择目的地国家"
                mode="multiple"
                allowClear
              />
            </dc-form-item>
            <dc-form-item name="product" label="云途产品">
              <ParamCodeCascader
                type="search"
                v-model:ids="queryForm.productList"
                :options="paramCodeData.lbu_products"
                placeholder="请选择云途产品"
                multiple
                allowClear
              />
            </dc-form-item>
            <dc-form-item name="product" label="竞争对手">
              <ParamCodeCascader
                v-model:value="queryForm.competitors"
                :options="paramCodeData.lbu_logistics_service_provider"
                placeholder="请选择竞争对手"
                allowClear
              />
            </dc-form-item>
            <dc-form-item name="timeType" label="时间筛选">
              <a-input-group compact>
                <a-select v-model:value="queryForm.timeType" :options="timeTypeEnum" style="width: 33%" />
                <CosRangePicker
                  v-model:startTime="queryForm.startTime"
                  v-model:endTime="queryForm.endTime"
                  style="width: 67%"
                />
              </a-input-group>
            </dc-form-item>
            <dc-form-item name="saleChanceRefId" label="客户ID">
              <a-input
                v-model:value="queryForm.saleChanceRefId"
                :maxlength="500"
                allowClear
                placeholder="请输入客户ID"
              />
            </dc-form-item>
            <dc-form-item name="id" label="商机ID">
              <a-input v-model:value="queryForm.id" :maxlength="500" allowClear placeholder="请输入商机ID" />
            </dc-form-item>
            <dc-form-item label="剩余变更时间">
              <a-select
                v-model:value="queryForm.remanentFollowDayType"
                allowClear
                placeholder="请选择"
                :options="remanentBusinessDayTypeEnum"
              />
            </dc-form-item>
            <dc-form-item name="remark" label="备注">
              <a-input
                v-model:value.trim="queryForm.remark"
                :maxlength="1000"
                allowClear
                placeholder="请输入备注"
              />
            </dc-form-item>
          </a-form>
        </template>

        <template #button>
          <a-button v-permission="'lbu_business_add_btn'" type="primary" @click="triggerAddOrEdit()">新增</a-button>
          <ImportBtn
            v-permission="'lbu_business_import_btn'"
            action="/lbu/api/saleChance/import"
            templateUrl="/lbu/api/saleChance/template/download"
            @success="handleQueryChange('search')"
          >导入
          </ImportBtn
          >
          <ExportButton
            v-permission="'lbu_business_export_btn'"
            appId="cos_lbu"
            taskType="305"
            :search="customerListFormat(queryForm)"
            >导出
          </ExportButton>
          <a-button
            v-permission="'lbu_business_del_btn'"
            danger
            @click="handleDelete()"
          >删除
          </a-button
          >
        </template>

        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'saleChanceName'">
            <router-link :to="{ path: '/lbu/business/view', query: { id: record.id } }">
              <div class="flex">
                <p class="time-out-flag" v-if="record.timeoutFlag === true">超时</p>
                <template v-if="text">
                  <BusinessName
                    appId="cos_lbu"
                    v-model:value="record.saleChanceName"
                    v-model:label="record.saleChanceNameByTxt"
                  />
                </template>
                <template v-else>--</template>
              </div>
            </router-link>
          </template>
          <template v-if="column.dataIndex === 'customerName'">
            <a href="javascript:;" @click="triggerCustomer(record)" v-if="text">{{ text }}</a>
            <span v-else>--</span>
          </template>
          <template v-if="column.dataIndex === 'product'">
            <ChannelText appId="cos_lbu" paramCode="lbu_products" :value="text" />
          </template>
          <template v-if="column.dataIndex === 'warehouseAttribution'">
            <ChannelText appId="cos_lbu" paramCode="lbu_warehouse_city" :value="text" />
          </template>
          <template v-if="column.dataIndex === 'competitors'">
            {{ competitorFormat(text) || '--' }}
          </template>
          <template v-if="column.dataIndex === 'status'">
            <dc-status :enums="statusEnum" :value="text" />
          </template>
          <template v-if="column.type === 'money'">
            <p>{{ formatThousandSeparator(text)}}</p>
          </template>
          <template v-if="column.dataIndex === 'action'">
            <a-button v-permission="'lbu_business_write_follow_btn'" type="link" @click="handleWriteFollowUp(record)"
              >写跟进</a-button
            >
            <SellerButton
              v-permission="'lbu_business_edit_btn'"
              type="link"
              :disabled="record.status===7"
              @click="triggerAddOrEdit(record.id)"
              >编辑</SellerButton
            >
            <a-button v-permission="'lbu_business_del_btn'" type="link" @click="handleDelete(record)">删除</a-button>
          </template>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { reactive, computed, ref, onMounted, toRaw } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import BusinessName from '@/components/BusinessName/index.vue'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import Modal from '@/hooks/modalType'
import {
  businessStatusEnum,
  clueAndcustomerPhaseEnum,
  remanentBusinessDayTypeEnum
} from '@/views/yuntuSales/commonEnum/dataConfig'
import { listByParamCodes } from '@/api/common'
import { customerListFormat } from '@/utils'
import type { ParamCodeItem } from '@/typings/common'
import { businessList, businessDelete, businessDetails, businessMultipleDelete } from '@/api/yuntuSales/chanceManage'
import { BusinessParams, BusinessListItem } from '@/typings/api/chanceManage'
import formatThousandSeparator from '@/utils/format'
import ImportBtn from '@/components/ImportBtn'
import { LbuSalesClueListItem } from '@/typings/api/clueManage'
import { salesClueDelete } from '@/api/yuntuSales/clueManage'
const router = useRouter()
const route = useRoute()

const statusEnum = businessStatusEnum.map((item) => ({
  name: item.label,
  value: item.value,
  color: item.color
}))
// 时间类型枚举
const timeTypeEnum = [
  { label: '创建时间', value: 0 },
  { label: '跟进时间', value: 1 },
  { label: '更新时间', value: 2 }
]
const paramCodeData = ref<{
  lbu_demand_country: ParamCodeItem[]
  lbu_products: ParamCodeItem[]
  lbu_logistics_service_provider: ParamCodeItem[]
  lbu_sales_category: ParamCodeItem[]
}>({
  lbu_demand_country: [], // 目的地国家
  lbu_products: [], // 出货渠道（云途产品）
  lbu_logistics_service_provider: [], // 物流服务商
  lbu_sales_category: []
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: ['lbu_demand_country', 'lbu_products', 'lbu_logistics_service_provider', 'lbu_sales_category']
  }).then((res) => {
    paramCodeData.value = res.data
  })
}
onMounted(() => {
  getByParamCodes()
})
const tableRef = ref()
const queryForm = reactive<BusinessParams>({ dataType: 'all', timeType: 0 })
const columns = computed(() => [
  { title: '商机名称', dataIndex: 'saleChanceName', fixed: 'left', width: 150 },
  { title: '客户代码', dataIndex: 'tmsCode' },
  { title: '客户名称', dataIndex: 'customerName', width: 200 },
  { title: '客户阶段', dataIndex: 'stage', dicData: clueAndcustomerPhaseEnum },
  { title: '客户标签', dataIndex: 'biCustomerStatus' },
  { title: '主账号代码', dataIndex: 'customerNumber' },
  { title: '客户ID', dataIndex: 'saleChanceRefId', width: 200 },
  { title: '商机ID', dataIndex: 'id', width: 200 },
  { title: '联系人姓名', dataIndex: 'contactName', cosType: 'mask' },
  { title: '手机号', dataIndex: 'contactMobile', cosType: 'mask' },
  { title: '目的地国家', dataIndex: 'requiredCountry', dicData: paramCodeData.value.lbu_demand_country },
  { title: '云途产品', dataIndex: 'product', width: 150 },
  { title: '客户归属区域', dataIndex: 'warehouseAttribution' },
  { title: 'OPR金额', dataIndex: 'planSaleAmount', type: 'money', width: 200, sorter: true },
  { title: 'OPR票数', dataIndex: 'mau', type: 'money', sorter: true },
  { title: 'OCR金额', dataIndex: 'committedSaleAmount', type: 'money', width: 200, sorter: true },
  { title: 'OCR票数', dataIndex: 'committedShipment', type: 'money', sorter: true },
  { title: 'OPR重量', dataIndex: 'oprWeight', type: 'money', sorter: true },
  { title: 'OCR重量', dataIndex: 'ocrWeight', type: 'money', sorter: true },
  { title: 'OPR方数', dataIndex: 'oprCube', type: 'money', sorter: true },
  { title: 'OCR方数', dataIndex: 'ocrCube', type: 'money', sorter: true },
  { title: '发货频次', dataIndex: 'shipmentFrequency', type: 'money', sorter: true },
  { title: '货物品类', dataIndex: 'goodsCategory', dicData: paramCodeData.value.lbu_sales_category },
  { title: '商机状态', dataIndex: 'status', width: 300 },
  { title: '竞争对手', dataIndex: 'competitors' },
  { title: '客户负责人', dataIndex: 'dutyByName' },
  { title: '备注', dataIndex: 'remark' },
  { title: '剩余变更时间', dataIndex: 'remanentFollowDays', width: 200, sorter: true },
  { title: '最新跟进时间', dataIndex: 'latestFollowTime', width: 190, sorter: true },
  { title: '创建人', dataIndex: 'createByName' },
  { title: '创建时间', dataIndex: 'createTime', width: 190, sorter: true },
  { title: '更新人', dataIndex: 'updateByName' },
  { title: '更新时间', dataIndex: 'updateTime', width: 190, sorter: true },
  { title: '操作', dataIndex: 'action', width: 180, fixed: 'right' }
])
const getList = (queryForm: BusinessParams, callBack: (res: any) => void) => {
  const params = customerListFormat(queryForm) // 处理客户名称和客户编码的批量查询参数

  const saleChanceRefId = params.saleChanceRefId
  if (saleChanceRefId !== undefined && saleChanceRefId.length > 0) {
    params.saleChanceRefIdList = saleChanceRefId.split(' ')
    params.saleChanceRefId = undefined
  }

  businessList(params).then((res) => {
    callBack(res)
  })
}
const selectedData = ref<BusinessListItem[]>([])
const onSelectRowsChange = (selectedRowKeys: string[], selectedRows: BusinessListItem[]) => {
  selectedData.value = selectedRows
}
const showMask = (record: BusinessListItem, callBack: (res: any) => void) => {
  businessDetails({ id: record.id }).then((res) => {
    callBack(res.data)
  })
}

const handleTabsChange = (val: any) => {
  queryForm.dataType = val
  if (val === 'me' && queryForm.dutyBy) {
    queryForm.dutyBy = undefined
  }
  tableRef.value?.search()
}
// 新增编辑函数
const triggerAddOrEdit = (id?: number) => {
  if (id) {
    router.push({ path: '/lbu/business/edit', query: { id } })
  } else {
    router.push('/lbu/business/add')
  }
}
// 跳转写跟进页面
const handleWriteFollowUp = (row: BusinessListItem) => {
  const { id: chanceId, saleChanceRefId: cosId, customerStatus } = row
  if (customerStatus == null) return false
  // 公海池的数据
  if (customerStatus === 0) {
    return message.warning('该线索已经流转到公海池')
  }
  router.push({
    path: '/lbu/followUpRecord/add',
    query: { followRefId: cosId as string, chanceId, returnPath: route.fullPath }
  })
}
const handleQueryChange = (type?: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
// const handleDelete = (row: BusinessListItem) => {
//   Modal.delete({
//     name: row.saleChanceNameByTxt,
//     onOk() {
//       businessDelete({ id: row.id }).then(() => {
//         message.success('删除商机成功')
//         tableRef.value?.delFetch()
//       })
//     }
//   })
// }
const handleDelete = (row?: BusinessListItem) => {
  if (!row && !selectedData.value?.length) {
    return message.error('请选择要删除的数据')
  }
  const idList: any[] = []
  const chanceName = []
  if (row) {
    idList.push(row.id)
    chanceName.push(row.saleChanceNameByTxt)
  } else {
    selectedData.value?.forEach((item) => {
      idList.push(item.id)
      chanceName.push(item.saleChanceNameByTxt)
    })
  }
  Modal.delete({
    name: chanceName.join(','),
    onOk() {
      businessMultipleDelete({ idList }).then(() => {
        message.success('删除商机成功')
        tableRef.value?.fetch()
        deleteRefresh(0)
      })
    }
  })
}
const deleteRefresh = (num: number) => {
  const params = toRaw(selectedData.value)
  params.splice(0, num)
  tableRef.value?.delFetch(params, 'clueId')
}
// 判断跳转客户或者线索详情页
const triggerCustomer = (row: BusinessListItem) => {
  const { customerStatus, saleChanceRefId } = row
  if (customerStatus == null) {
    return false
  } else if (customerStatus === 0) {
    // 公海池的数据
    return message.warning('该线索已经流转到公海池')
  } else if (customerStatus === 1 || customerStatus === 3) {
    // 正常线索的数据
    router.push({ path: '/lbu/salesClue/view', query: { clueId: saleChanceRefId as string } })
  } else if (customerStatus >= 10 && customerStatus <= 14) {
    // 潜在客户的数据
    router.push({ path: '/lbu/potential/view', query: { cosId: saleChanceRefId as string } })
  } else if (customerStatus >= 30 && customerStatus <= 39) {
    // 成交客户的数据
    router.push({ path: '/lbu/clients/view', query: { cosId: saleChanceRefId as string } })
  } else {
    return false
  }
}
/**
 * 竞争对手序列化
 * @param arr 对手数组
 */
const competitorFormat = (arr: any) => {
  if (!Array.isArray(arr) || !arr?.length) return '--'
  const listEnum = paramCodeData.value.lbu_logistics_service_provider
  const result: string[] = []
  arr.forEach((ele) => {
    const item = listEnum.find((e) => e.id === ele)
    if (item) result.push(item.name as string)
  })
  return result.join('、')
}
</script>
<script lang="ts">
export default { name: 'DcCosLbuBusiness' }
</script>

<style lang="scss" scoped></style>
